import { TextField } from '@mui/material';
import Box from '@mui/material/Box';
import ButtonCustom from 'components/ButtonCustom';
import Spinner from 'components/Spinner';
import UseAuthContext from 'context/AuthContext';
import { useSnackbar } from 'notistack';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { getPrivateAreaDetails } from 'services/private-area-services';
import { USER_ROLES } from 'utils/constants';
import { getErrorHtmlContent } from 'utils/utils';

const UserPersonalInfoEdit = ({ updatePrivateDetails }: any) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { role } = useContext(UseAuthContext);
  const isInspectorRole = role === USER_ROLES.INSPECTOR || role === USER_ROLES.INSPECTOR_MANAGER;
  const {
    data,
    isLoading: dataLoading,
    refetch: refetchPersonalDetails,
  } = useQuery('getPrivateAreaDetails', getPrivateAreaDetails);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    role: ''
  });

  useEffect(() => {
    if (data?.data) {
      setFormData({
        name: data.data.name || '',
        phone: data.data.phone || '',
        role: data.data.role || ''
      });
    }
  }, [data]);

  const handleChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      [field]: e.target.value
    }));
  };
  
  const handleClick = async (e: React.FormEvent) => {
    try {
      e.preventDefault();
      await updatePrivateDetails({
        name: formData.name,
        phone: formData.phone,
        role: formData.role,
        type: 'personal'
      });
      const apiResponse = await refetchPersonalDetails();
      if (apiResponse) {
        enqueueSnackbar(t('PRIVATE_AREA_PERSONAL_INFO_UPDATE_SUCCESS'), {
          variant: 'success',
        });
      }
    } catch (error: any) {
      if (error) {
        enqueueSnackbar(getErrorHtmlContent(error), { variant: 'error' });
        console.log('onError', error);
      }
    }
  };

  if (dataLoading) {
    return <Spinner />;
  }

  return (
    <Box component='form' sx={{ mx: '2rem', display:"flex", gap:"30px", width:{xs:"100%", md:"480px"} }} className='tab-content-form'>
      <TextField
        margin='normal'
        fullWidth
        variant='standard'
        id='fullname'
        name='fullname'
        autoFocus
        label={t('USER_EDIT_PI_NAME')}
        autoComplete='off'
        autoCorrect='off'
        helperText={isInspectorRole ? '' : t('USER_EDIT_PI_NAME_HELPER_TEXT')}
        value={formData.name}
        onChange={handleChange('name')}
      />
      <TextField
        margin='normal'
        variant='standard'
        fullWidth
        name='mobile'
        label={t('USER_EDIT_PI_MOBILE')}
        id='mobile'
        type='text'
        dir='ltr'
        sx={{
          textAlign: 'left',
        }}
        autoComplete='off'
        autoCorrect='off'
        value={formData.phone}
        onChange={handleChange('phone')}
        helperText={t('USER_EDIT_PI_MOBILE_HELPER_TEXT')}
      />
      {!isInspectorRole && <TextField
        margin='normal'
        variant='standard'
        fullWidth
        name='role'
        label={t('USER_EDIT_PI_ROLE')}
        id='position'
        type='text'
        autoComplete='off'
        autoCorrect='off'
        value={formData.role}
        onChange={handleChange('role')}
        helperText={t('USER_EDIT_PI_ROLE_HELPER_TEXT')}
      />}
      <ButtonCustom
        color='primary'
        type='submit'
        variant='contained'
        onClick={handleClick}
      >
        {t('SAVE_BUTTON')}
      </ButtonCustom>
    </Box>
  );
};

export default UserPersonalInfoEdit;
